import React from "react";
import { motion, useInView } from "framer-motion";
import * as styles from "./Recipes.module.scss";
import RecipeCard from "./RecipeCard";

const Recipes = ({ colorCategory, recipeRelated }) => {
  return (
    <div className={styles.categories__category}>
      {recipeRelated?.map((recipe) => (
        <MotionRecipeCard
          key={recipe.title}
          recipe={recipe}
          colorCategory={colorCategory}
        />
      ))}
    </div>
  );
};

const MotionRecipeCard = ({ recipe, colorCategory }) => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: false, threshold: 4.0 });

  const variants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={variants}
      transition={{ duration: 0.6 }}
    >
      <RecipeCard recipe={recipe} colorCategory={colorCategory} />
    </motion.div>
  );
};

export default Recipes;
